import ErrorUtils from 'utils/error-utils';
export const routeToCheckout = ({ spot }) => {
    return () => {
        const expressCheckoutUrl = spot.selectedRate?.expressCheckoutUrl;
        if (expressCheckoutUrl) {
            window.location.href = expressCheckoutUrl;
        }
        else {
            ErrorUtils.sendSentryMessage({
                error: new Error('routeToCheckout called without expressCheckoutUrl'),
                additionalData: {
                    spotId: spot?.spotId,
                    parkingSpotId: spot?.parking_spot_id,
                    hasSelectedRate: Boolean(spot?.selectedRate),
                },
            });
        }
    };
};
